import { PropsWithChildren } from 'react';

import styled from 'styled-components';

import { getCurrencySymbol } from '@utils/utils';

const Wrapper = styled.div`
  padding: 18px 15px;
`;

const Header = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

const Guest = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

const Discount = styled.span`
  opacity: 0.5;
  font-size: 16px;
  line-height: normal;
  color: ${({ theme }) => theme.palette.darkGrey};
  text-decoration: line-through;
  margin-right: 10px;
`;

const Price = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

type GuestPriceInfoType = {
  prices: { price: number; discount: number }[];
  title?: string;
  guestName: string;
  currency: string;
};

const GuestPriceInfo = ({
  prices,
  title,
  guestName,
  currency,
}: GuestPriceInfoType) => (
  <Wrapper>
    {title ? <Header>{title}</Header> : null}
    {prices?.map(({ price, discount }, index) => (
      <Info key={index}>
        <Guest>{`${index + 1} ${guestName}`}</Guest>
        {discount && discount != price ? (
          <>
            <Discount>{`${price} ${getCurrencySymbol(currency)}`}</Discount>
            <Price>{`${discount} ${getCurrencySymbol(currency)}`}</Price>
          </>
        ) : (
          <Price>{`${price} ${getCurrencySymbol(currency)}`}</Price>
        )}
      </Info>
    ))}
  </Wrapper>
);

const ChildInfo = ({
  title,
  guestName,
  children,
}: PropsWithChildren<{ title: string; guestName: string }>) => (
  <Wrapper>
    <Header>{title}</Header>
    <Info>
      <Guest>{`${guestName}`}</Guest>
      {children}
    </Info>
  </Wrapper>
);

export default GuestPriceInfo;
export { ChildInfo };
